import {Row, Col, Alert} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {connect} from "react-redux";

export const NoteCreated = () => {
    let {id} = useParams();

    return (
        <Row>
            <Col>
                <Alert variant={"success"}>
                    <Alert.Heading>Success</Alert.Heading>
                    Note was successfully created with Id&nbsp;
                    <Alert.Link href={`/notes/${id}/edit`}>{id}</Alert.Link>
                </Alert>
            </Col>
        </Row>
    );
}

export default connect()(NoteCreated);
